import React, { memo, useCallback } from 'react'
import { Popper, Grow, Paper, ClickAwayListener } from '@mui/material'
import { PopperMenuProps } from './PopperMenu.types'

function PopperMenu({
    anchorRef,
    placement = 'bottom-end',
    children,
    onClose,
}: PopperMenuProps) {
    const handleClose = useCallback(
        (event: MouseEvent | TouchEvent): void => {
            if (
                anchorRef.current &&
                anchorRef.current.contains(event.target as HTMLElement)
            ) {
                return
            }
            onClose()
        },
        [onClose, anchorRef]
    )

    return (
        <Popper
            open
            anchorEl={anchorRef.current}
            transition
            disablePortal
            placement={placement}
        >
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{
                        transformOrigin:
                            placement === 'bottom'
                                ? 'center top'
                                : 'center bottom',
                    }}
                >
                    <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                            {children}
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    )
}

export default memo(PopperMenu)
